import { render, staticRenderFns } from "./table-header.vue?vue&type=template&id=456f9249&scoped=true"
import script from "./table-header.vue?vue&type=script&lang=js"
export * from "./table-header.vue?vue&type=script&lang=js"
import style0 from "./table-header.vue?vue&type=style&index=0&id=456f9249&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456f9249",
  null
  
)

export default component.exports